<template>
  <div class="d-flex justify-content-center">
    <div
      class="spinner-border"
      role="status"
      :style="{ width: psize, height: psize }"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    psize() {
      const sizes = {
        xs: '.7rem',
        sm: '1rem',
        md: '2rem',
        lg: '3rem',
        xl: '5rem',
      };

      return sizes[this.size] || sizes.md;
    },
  },
};
</script>

<style></style>
